<template>
  <div class="container">
    <points-config-automatic-points-title initial-tab-value="badges" />
    <points-config-badges-table class="m-tx4" />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const pointsConfig = computed(() => state.pointsConfig.config);
</script>
